import { styled } from '@mui/material/styles';
import { TextField } from '@mui/material';

export const SuffixTextField = styled(TextField)(({ theme }) => ({
  width: '100%',
  backgroundColor: theme.palette.customColors.inputBackground,
  border: '1px solid grey',
  borderRadius: '8px',
  '& .MuiInputBase-root': {
    borderRadius: '8px',
    padding: '12px 3px 12px 3px',
  },
  '& .MuiInputBase-input': {
    padding: '0px 6px',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      border: 'none',
    },
  },
}));
